var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "sidebar-modal" } }, [
    _c(
      "section",
      {
        ref: "modal",
        staticClass: "sidebar-modal-wrapper",
        attrs: { tabindex: "0" },
        on: {
          click: _vm.close,
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            ) {
              return null
            }
            return _vm.close($event)
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "sidebar-modal-wrapper-inner",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c(
              "span",
              { staticClass: "sidebar-modal-close", on: { click: _vm.close } },
              [_c("i", { staticClass: "icon icon-close" })]
            ),
            _vm._v(" "),
            _c("header", [_vm._t("header")], 2),
            _vm._v(" "),
            _c(
              "main",
              { staticClass: "sidebar-modal-wrapper-content" },
              [_vm._t("body")],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }